export const getBrowser = () => {
  const ua = navigator.userAgent;

  if (/chrome|crios/i.test(ua) && !/edg|opr|brave/i.test(ua)) {
    const match = ua.match(/(?:chrome|crios)\/([\d.]+)/i);
    return { name: 'Chrome', version: match ? match[1] : 'Unknown' };
  }

  if (/firefox|fxios/i.test(ua)) {
    const match = ua.match(/(?:firefox|fxios)\/([\d.]+)/i);
    return { name: 'Firefox', version: match ? match[1] : 'Unknown' };
  }

  if (/safari/i.test(ua) && !/chrome|crios|edg|opr|brave/i.test(ua)) {
    const match = ua.match(/version\/([\d.]+)/i);
    return { name: 'Safari', version: match ? match[1] : 'Unknown' };
  }

  if (/edg/i.test(ua)) {
    const match = ua.match(/edg\/([\d.]+)/i);
    return { name: 'Edge', version: match ? match[1] : 'Unknown' };
  }

  if (/opr/i.test(ua)) {
    const match = ua.match(/opr\/([\d.]+)/i);
    return { name: 'Opera', version: match ? match[1] : 'Unknown' };
  }

  return { name: 'Unknown', version: 'Unknown' };
};

export const getOS = () => {
  const ua = navigator.userAgent;

  if (/windows nt/i.test(ua)) {
    const name = 'Windows';
    if (/windows nt 10\.0/i.test(ua)) return { name, version: '10' };
    if (/windows nt 11\.0/i.test(ua)) return { name, version: '11' };
    if (/windows nt 6\.3/i.test(ua)) return { name, version: '8.1' };
    if (/windows nt 6\.2/i.test(ua)) return { name, version: '8' };
    if (/windows nt 6\.1/i.test(ua)) return { name, version: '7' };
    return { name, version: 'Unknown' };
  }

  if (/mac os x/i.test(ua)) {
    const match = ua.match(/mac os x ([\d_]+)/i);
    if (match) {
      return { name: 'macOS', version: match[1].replace(/_/g, '.') };
    }
    return { name: 'macOS', version: 'Unknown' };
  }

  if (/android/i.test(ua)) {
    const match = ua.match(/android ([\d.]+)/i);
    return { name: 'Android', version: match ? match[1] : 'Unknown' };
  }

  if (/iphone|ipad|ipod/i.test(ua)) {
    const match = ua.match(/os ([\d_]+)/i);
    return {
      name: 'iOS',
      version: match ? match[1].replace(/_/g, '.') : 'Unknown',
    };
  }

  if (/linux/i.test(ua)) {
    return { name: 'Linux', version: 'Unknown' };
  }

  return { name: 'Unknown', version: 'Unknown' };
};

export const getMetadata = () => {
  const browser = getBrowser();
  const os = getOS();

  return {
    platform_type: /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
      ? 'M'
      : 'D',
    platform_resolution: `${window.screen.width}x${window.screen.height}`,
    platform_os: `${os.name} ${os.version}`,
    browser_name: `${browser.name} ${browser.version}`,
    browser_timezone:
      Intl.DateTimeFormat().resolvedOptions().timeZone || 'Unknown',
  };
};
